import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/device`,{params:searchParams});
    }

    get(deviceId){
      return this.http.get(`${environment.baseUrl}/device/`+deviceId);
    }

    edit(deviceId,formData){
      return this.http.put(`${environment.baseUrl}/device/`+deviceId,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/device`,formData);
    }

    delete(deviceId){
      return this.http.delete(`${environment.baseUrl}/device/`+deviceId);
    }

}
